var sApp = sApp || {};

sApp.$W = $(window);
sApp.$D = $(document);

function library(module) {
    $(function() {
        if (module.init) {
            module.init();
        }
    });
    return module;
}

function sendGa(category, action, label) {
    ga('send', {
        hitType: 'event',
        eventCategory: category,
        eventAction: action,
        eventLabel: label
    });
}

$(function() {

    var share = Ya.share2('ya-share2');

    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) {
        $('html').addClass('_safari');
    };

    var ua = window.navigator.userAgent;
    var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
    var webkit = !!ua.match(/WebKit/i);
    var iOSSafari = iOS && webkit && !ua.match(/CriOS/i);

    svg4everybody();

    if ($('.js-inner-page').length) {
        $('.js-inner-page').addClass('animated');
    }

    $(window).on("orientationchange", function( event ) {
        if(($(window).width() < 961) && (window.orientation === 90 || window.orientation === -90)) {
            $('body').addClass('turn');
        } else {
            $('body').removeClass('turn');
        }
    });

    function createFullpage() {
        $('#fullpage').fullpage({
            fixedElements: '#header',
            anchors: ['intro', 'heroes', 'test', 'about'],
            //menu: '#menu',
            fitToSection: true,
            keyboardScrolling: true,
            animateAnchor: true,
            verticalCentered: false,
            scrollOverflow: true,
            scrollOverflowOptions: {
                click:false,
                tap: true
            },
            css3: false,
            scrollingSpeed: 500,
            resize: true,
            navigation: true,
            navigationPosition: 'left',
            licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',
            //normalScrollElements: '.popup'
            onLeave: function(origin, destination, direction) {
                if (destination.index === 1) {
                    $('.swiper-slide-active').addClass('swiper-slide-animate delay');
                    $('.swiper-slide').addClass('lines-animate');
                    heroesSlider.autoplay.start();
                    sendGa('main', 'click', 'second');
                } else if (destination.index === 2) {
                    sendGa('main', 'click', 'third');
                } else if (destination.index === 2) {
                    sendGa('main', 'click', 'fourth');
                }
                if (origin.index === 1) {
                    $('.swiper-slide').removeClass('swiper-slide-animate lines-animate');
                    heroesSlider.autoplay.stop();
                }
            },
        });
    }

    createFullpage();

    var yandex = /yabrowser/.test(navigator.userAgent.toLowerCase());
    if (yandex) {
        setTimeout(function () {
            fullpage_api.reBuild();
        }, 500);
    }

    if ($('.heroes-slider').length) {
        var heroesSlider = new Swiper('.heroes-slider', {
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true
            },
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
            on: {
                slideChange: function() {
                    $('.swiper-slide').removeClass('swiper-slide-animate delay');

                    setTimeout(function () {
                        $('.swiper-slide').eq(heroesSlider.activeIndex).addClass('swiper-slide-animate');
                    }, 400)

                },

                slideChangeTransitionStart: function() {
                    $('.js-progress-bar').removeClass('transition');
                },

                slideChangeTransitionEnd: function() {
                    $('.js-progress-bar').addClass('transition');
                }
            },
        });

        var bullets = $('.heroes-slider .swiper-pagination-bullet');
        $.each(bullets, function() {
            var order = $(this).index() + 1;
            $(this).text(order);
        })
    }

    $('.logo-afisha').on('click', function() {
        sendGa('main', 'click', 'afisha logo');
    });

    $('.logo').on('click', function() {
        sendGa('main', 'click', 'adv logo');
    });

    $('.ya-share2__item_service_twitter').on('click', function () {
        if ($('.result-share').length) {
            sendGa('test', 'click', 'share result tw');
        } else {
            sendGa('main', 'click', 'main share tw');
        }
    });

    $('.ya-share2__item_service_facebook').on('click', function () {
        if ($('.result-share').length) {
            sendGa('test', 'click', 'share result fb');
        } else {
            sendGa('main', 'click', 'main share fb');
        }
    });

    $('.ya-share2__item_service_vkontakte').on('click', function () {
        if ($('.result-share').length) {
            sendGa('test', 'click', 'share result vk');
        } else {
            sendGa('main', 'click', 'main share vk');
        }
    });

    $('.ya-share2__item_service_telegram').on('click', function () {
        if ($('.result-share').length) {
            sendGa('test', 'click', 'share result tg');
        } else {
            sendGa('main', 'click', 'main share tg');
        }
    });

    $('.js-go-test').on('click', function() {
        sendGa('main', 'click', 'go to test');
    });

    $('.about__link').on('click', function() {
        sendGa('main', 'click', 'know more');
    });

    $('.interview-link').on('click', function() {
        sendGa('interview', 'click', 'another');
    });

    $('.interview-block__link-back').on('click', function() {
        sendGa('interview', 'click', 'back');
    });

    $('.result__text a').on('click', function() {
        sendGa('test', 'click', 'adv facebook');
    });

    $('.result__link-share').on('click', function() {
        sendGa('test', 'click', 'adv mail');
    });

    $('.home-button').on('click', function() {
        sendGa('test', 'click', 'back');
    });

    if ($('.interview-block').length) {
        var scrollPercent;

        $(window).on('scroll', function(){
            var s = $(window).scrollTop(),
                d = $(document).height(),
                c = $(window).height(),
                percent;

            percent = (s / (d - c)) * 100;
            scrollPercent = Math.ceil(percent / 10) * 10;

            if (scrollPercent > 100) {
                scrollPercent = 100;
            }
        });

        $(window).on('beforeunload', function() {
            sendGa('interview', 'scroll', scrollPercent+'%');
        });
    }
});